import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EconomicDevelopmentMapItem } from '../../definitions/economic-development-map-item';
import { MapItemComponent } from '@ui/shared/util-map';

import { DetailViewModule } from '@ui/shared/ui-detail-view';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-economic-development-map-item-details',
    templateUrl: './economic-development-map-item-details.component.html',
    styleUrls: ['./economic-development-map-item-details.component.scss'],
    imports: [
        DetailViewModule,
    ],
})
export class EconomicDevelopmentMapDetailsComponent implements MapItemComponent<EconomicDevelopmentMapItem> {
    public mapItem = input<EconomicDevelopmentMapItem | undefined>();
}
